export default __webpack_public_path__ + "static/media/abld_inverted_math.ed8da43367b9c3e63e69e640f91e61f2.svg";